import { v1 as uuid } from 'uuid';
import { Roles } from '../services/auth';

// base
import HomePage from "../pages/home/Home";
import ContactPage from "../pages/contact/Contact";
import RedirectPage from "../pages/home/Redirect";

// public
import ShortLinkPage from "../pages/shortlink/ShortLink";
import LoginPage from "../pages/auth/Login";
import ConfirmPage from "../pages/auth/Confirm";
import LogoutPage from "../pages/auth/Logout";
import TermsPage from "../pages/home/Terms";
import PrivacyPolicyPage from '../pages/home/PrivacyPolicy';

// auth 
import ResetPage from "../pages/auth/Reset";
import ResetForcePage from "../pages/auth/ResetForce";

// private
import ProfilePage from "../pages/profile/Profile";
import ProfileUserPage from "../pages/profile/LoanOfficer";
import ProfilePublicPage from "../pages/profile/ProfilePublic";
import NotificationsPage from "../pages/profile/Notifications";

// admin
import AdminPage from "../pages/admin/Admin";
import AdminCampaignsCreatePage from "../pages/admin/campaign/AdminCampaignCreate";
import AdminLeadsPage from "../pages/admin/AdminLeads";
import AdminCampaignsPage from "../pages/admin/campaign/AdminCampaigns";
import AdminCampaignPage from "../pages/admin/campaign/AdminCampaign";
import AdminTemplatesPage from "../pages/admin/template/AdminTemplates";
import AdminUsersPage from "../pages/admin/AdminUsers";
import AdminCreateUsersPage from "../pages/admin/AdminCreateUser";
import AdminLogsPage from "../pages/admin/AdminLogs";
import AdminAddressesPage from "../pages/admin/AdminAddresses";

import AdminCampaignsRunPage from "../pages/admin/campaign/AdminCampaignsRun";
import AdminCampaignRunPage from "../pages/admin/campaign/AdminCampaignRun";

// campaigns
import CampaignsPage from "../pages/campaign/Campaigns";
import CampaignPage from "../pages/campaign/Campaign";
import CampaignContactPage from "../pages/campaign/CampaignContact";
import CampaignClicksPage from "../pages/campaign/CampaignClicks"
import CampaignRepliesPage from "../pages/campaign/CampaignReplies"
import CampaignFavoritesPage from "../pages/campaign/CampaignFavorites"
import NewCampaignPage from "../pages/campaign/NewCampaign";
import NewCampaignDetailsPage from "../pages/campaign/NewCampaignDetails";
import NewCampaignTemplatePage from "../pages/campaign/NewCampaignTemplate";
import NewCampaignBilling from "../pages/campaign/NewCampaignBilling";
import NewCampaignTimeline from "../pages/campaign/NewCampaignTimeline";

import NextActionPage from "../pages/next-action/NextAction";
import LeadsPage from "../pages/next-action/Leads";

// orgs
import OrganizationsPage from '../pages/team/Organizations';
import OrganizationPage from '../pages/team/Organization';
import BranchPage from '../pages/team/Branch';
import TeamUserPage from '../pages/team/TeamUser';

// home
import PaymentDesignCenter from '../pages/payment/DesignCenter';

/*

/admin/campaigns/today
/admin/campaigns/run
/admin/campaign/{id}/run

*/

const routes = {
  public: [
    // auth
    {
      name: "Logout",
      path: "/auth/logout",
      exact: true,
      component: LogoutPage,
    },
    {
      name: "Login",
      path: "/auth/login",
      exact: true,
      component: LoginPage,
    },
    {
      name: "Reset Password",
      path: "/auth/reset/force",
      exact: true,
      component: ResetForcePage,
      roles: ['user']
    },
    {
      name: "Shortlink",
      path: "/l/:id",
      exact: true,
      component: ShortLinkPage,
    },
    {
      name: "Redriect",
      path: "/redirect",
      exact: true,
      component: RedirectPage,
    },
    {
      name: "Confirm",
      path: "/auth/confirm",
      exact: true,
      component: ConfirmPage,
    },
    {
      name: "Home", 
      path: "/",
      exact: true,
      component: HomePage,
    },
    {
      name: "Terms", 
      path: "/terms",
      exact: true,
      component: TermsPage,
    },
    {
      name: "Terms", 
      path: "/privacy-policy",
      exact: true,
      component: PrivacyPolicyPage,
    },
    {
      name: "About Us",
      path: "/about-us",
      exact: true,
      component: ContactPage,
    },
    {
      name: "Contact",
      path: "/contact",
      exact: true,
      component: ContactPage,
    },
    {
      name: 'Payment Design Center',
      path: '/payment-design-center',
      exact: true,
      component: PaymentDesignCenter
    },
    {
      name: 'Payment Design Center',
      path: '/payment-design-center/:id',
      exact: true,
      component: PaymentDesignCenter
    },
  ],
  private: [
    // auth
    {
      name: "Reset Password",
      path: "/auth/reset",
      exact: true,
      component: ResetPage,
      roles: ['user']
    },
    // admin
    {
      name: "Admin",
      path: "/admin",
      exact: true,
      component: AdminPage,
      roles: ['admin'],
    },
    {
      name: "Admin Leads",
      path: "/admin/leads",
      exact: true,
      component: AdminLeadsPage,
      roles: ['admin'],
    },
    {
      name: "Admin Campaigns",
      path: "/admin/campaigns",
      exact: true,
      component: AdminCampaignsPage,
      roles: ['admin'],
    },
    {
      name: "Admin Campaigns",
      path: "/admin/campaign/new",
      exact: true,
      component: AdminCampaignsCreatePage,
      roles: ['admin'],
    },
    {
      name: "Admin Campaign",
      path: "/admin/campaign/:id",
      exact: true,
      component: AdminCampaignPage,
      roles: ['admin'],
    },
    {
      name: "Admin Templates",
      path: "/admin/templates",
      exact: true,
      component: AdminTemplatesPage,
      roles: ['admin', 'superadmin'],
    },
    {
      name: "Admin Users",
      path: "/admin/users",
      exact: true,
      component: AdminUsersPage,
      roles: ['admin', 'superadmin'],
    },
    {
      name: "Admin Users",
      path: "/admin/user/create",
      exact: true,
      component: AdminCreateUsersPage,
      roles: ['admin', 'superadmin'],
    },
    {
      name: "Admin Logs",
      path: "/admin/logs",
      exact: true,
      component: AdminLogsPage,
      roles: ["superadmin"],
    },
    {
      name: "Admin Addresses",
      path: "/admin/addresses",
      exact: true,
      component: AdminAddressesPage,
      roles: ['admin', 'superadmin'],
    },
    {
      name: "Admin Campaigns Run",
      path: "/admin/campaigns/run",
      exact: true,
      component: AdminCampaignsRunPage,
      roles: ['admin', 'textadmin'],
    },
    {
      name: "Admin Campaign Run",
      path: "/admin/campaign/:id/run",
      exact: true,
      component: AdminCampaignRunPage,
      roles: ['admin', 'textadmin'],
    },
    // campaigns
    {
      name: "Campaigns",
      path: "/campaigns",
      exact: true,
      component: CampaignsPage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "Campaign Replies",
      path: "/campaign/replies",
      exact: true,
      component: CampaignRepliesPage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "Campaign Clicks",
      path: "/campaign/clicks",
      exact: true,
      component: CampaignClicksPage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "Campaign Favorites",
      path: "/campaign/favorites",
      exact: true,
      component: CampaignFavoritesPage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "Campaign",
      path: "/campaign/:id",
      exact: true,
      component: CampaignPage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "Campaign Contact",
      path: "/campaign/:campaignId/contact/:contactId",
      exact: true,
      component: CampaignContactPage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "Campaign Contact",
      path: "/campaign/:campaignId/contact/:contactId/type/:type",
      exact: true,
      component: CampaignContactPage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "New Campaign",
      path: "/campaign/new/start",
      exact: false,
      component: NewCampaignPage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "New CampaignDetails",
      path: "/campaign/new/details",
      exact: true,
      component: NewCampaignDetailsPage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "New CampaignTemplate",
      path: "/campaign/new/template",
      exact: true,
      component: NewCampaignTemplatePage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "New CampaignTimeline",
      path: "/campaign/new/timeline",
      exact: true,
      component: NewCampaignTimeline,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "New CampaignBilling",
      path: "/campaign/new/billing",
      exact: true,
      component: NewCampaignBilling,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "Next Action",
      path: "/campaigns/next-action",
      exact: true,
      component: NextActionPage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    {
      name: "Leads",
      path: "/leads",
      exact: true,
      component: LeadsPage,
      roles: ["admin", "agent", "campaigns", "user"],
    },
    // profile
    {
      name: "Profile",
      path: "/profile",
      exact: true,
      component: ProfilePage,
      roles: ["user"],
    },
    {
      name: "Profile User",
      path: "/profile/user/:id",
      exact: true,
      component: ProfileUserPage,
      roles: ["user"],
    },
    {
      name: "Profile Public",
      path: "/p/:id",
      exact: true,
      component: ProfilePublicPage,
      roles: ["user"],
    },
    {
      name: "Notifications",
      path: "/profile/notifications",
      exact: true,
      component: NotificationsPage,
      roles: ["user"],
    },
    // organizations
    {
      name: 'Organizations',
      path: '/organizations',
      exact: true,
      component: OrganizationsPage,
      roles: ['user', 'admin']
    },
    {
      name: 'Organization',
      path: '/organization/:id',
      exact: true,
      component: OrganizationPage,
      roles: ['user', 'admin']
    },
    {
      name: 'Organization',
      path: '/organization/:id/user/:id',
      exact: true,
      component: OrganizationPage,
      roles: ['user', 'admin']
    },
    {
      name: 'Organization Branches',
      path: '/organization/:id/branch/:branchid',
      exact: true,
      component: BranchPage,
      roles: ['user', 'admin']
    },
    {
      name: 'Organization Branches',
      path: '/organization/:id/branch/:branchid/user/:userid',
      exact: true,
      component: TeamUserPage,
      roles: ['user', 'admin']
    },
  ],
};

export default routes;



// WEBPACK FOOTER //
// ./src/config/routes.ts